import React, { useEffect, useState } from "react";
//internal and external components import
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import {
  TableRow,
  Checkbox,
  Chip,
  TextField,
  ThemeProvider,
  createTheme,
  Tooltip,
  Typography,
} from "@mui/material";
import { stableSort, getComparator } from "../../common/SortSupport";
import { EnhancedTableHead } from "../EnhancedTableHead";
import { Box } from "@mui/material";
import logo from "../../assets/icons/JLogo.svg";
import SelectBoxPrimary from "../SelectBoxPrimary";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faXmark,
  faCheck,
  faLinkSlash,
  faEyeSlash,
  faBicycle,
  faTrashCan,
  faTrash,
  faCirclePlus,
  faLock,
} from "@fortawesome/free-solid-svg-icons";
import TableSkeleton from "../TableSkeleton";
import {
  actionsRegex,
  DATE_FORMAT,
  formatDate,
  genUID,
  selectedActionRegex,
  selectedProjectActionRegex,
  selectedProjectRegex,
} from "../../common/StaticExports";
import { useDispatch, useSelector } from "react-redux";
import NestedThreeDotMenu from "../NestedThreeDotMenu";
import PerformanceActionDetailPopper from "../../containers/PerformanceActionDetailPopper";
import PerformanceNewActionDetailPopper from "../../containers/PerformanceNewActionDetailPopper";
import ButtonDefault from "../ButtonDefault";
import { useTranslation } from "react-i18next";
import {
  archiveAction,
  deleteAction,
  getAllActions,
  updateAction,
} from "../../api/action";
import { unassignAction } from "../../api/standards";
import ActionSelectBox from "../SearchSelectBox/ActionSelectBox";
import StaffSelectBox from "../SearchSelectBox/StaffSelectBox";
import DateSelector from "../DateSelector";
import { getStaff } from "../../api/user";
import { getClubDepartments } from "../../api/club";
import { editProject } from "../../api/projects";
import {
  setProjectDetails,
  setSelectedProject,
} from "../../redux/reducers/actionPlan";
import CommentsDocsActionsIconWrapper from "../CommentsDocsActionsIconWrapper";
import { useLocation, useNavigate } from "react-router";
import AccessManager from "../../containers/AccessManager";
import { setSnackBarData } from "../../redux/reducers/common";
import { restrictActionUsers } from "../../api/evaluation";

const theme = createTheme({
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: "6px 16px",
        },
      },
    },
    MuiStack: {
      styleOverrides: {
        root: {
          display: "inline",
          width: "90px",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          minWidth: "90px !important",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontSize: 12,
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          width: 18,
          height: 18,
        },
      },
    },
  },
});

const PerformanceActionsTable = (props: any) => {
  const {
    data,
    project,
    isLoading,
    isAddLoading,
    from,
    updateNewAction,
    isReadOnly,
  } = props;

  var head = [
    {
      key: "",
      displayName: "action id",
    },
    {
      key: "name",
      displayName: "action",
    },
    {
      key: "",
      displayName: "",
    },
    {
      key: "projectName",
      displayName: "project",
    },
    {
      key: "ragb",
      displayName: "status",
    },
    {
      key: "ownerName",
      displayName: "owner",
    },
    {
      key: "departmentName",
      displayName: "department",
    },
    {
      key: "dueDate",
      displayName: "due date",
    },
    {
      key: "",
      displayName: "",
    },
  ];

  //supporting contents
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [openActionDetail, setOpenActionDetail] = React.useState(false);
  const isAdmin = useSelector((state: any) => state.common.isAdmin);
  const clubDetails = useSelector((state: any) => state.clubDetails);
  const isActions = useSelector((state: any) => state.actionPlan.isActions);
  const [dataList, setDataList] = useState(data);
  const selectedArchivedStatuses = useSelector(
    (state: any) => state.actionPlan.actionsArchivedFilter
  );
  const selectedActionsLinkedTo = useSelector(
    (state: any) => state.actionPlan.actionsLinkedToFilter
  );
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const threeDotMenuOptions = isActions
    ? [
        { label: "Archive Action", icon: faEyeSlash, isDisabled: false },
        { label: "Delete Action", icon: faTrash, isDisabled: false },
        { label: "Manage Access", icon: faLock, isDisabled: false },
      ]
    : [
        { label: "Unlink Action", icon: faLinkSlash, isDisabled: false },
        { label: "Archive Action", icon: faEyeSlash, isDisabled: false },
        { label: "Delete Action", icon: faTrash, isDisabled: false },
        { label: "Manage Access", icon: faLock, isDisabled: false },
      ];
  const [actionData, setActionData]: any = useState({});
  const [addNewAction, setAddNewAction] = useState(false);
  const [newActionData, setNewActionData]: any = useState({});
  const [actionList, setActionList] = useState([]);
  const [staffList, setStaffList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  // const details = useSelector((state:any) => state.actionPlan.selectedProject);
  const selectedProject = useSelector(
    (state: any) => state.actionPlan.selectedProject
  );
  const actionsSearchString = useSelector(
    (state: any) => state.actionPlan.actionsSearchString
  );
  const selectedDepartments = useSelector(
    (state: any) => state.common.departmentsFilter
  );
  const initialAccessState = {
    isOpen: false,
    itemId: null,
  }
  const [manageAccess, setManageAccess] = React.useState(initialAccessState);

  const handleThreedotMenuClick = async (selctedAction: any, action: any) => {
    switch (selctedAction) {
      case "Unlink Action":
        unassignAction({ projectId: project.id, actionId: action?.id });
        break;
      case "Delete Action":
        {
          await deleteAction({ actionId: action?.id });
          const tempArr = dataList.filter((x: any) => x.id != action.id);
          setDataList(tempArr);
        }
        break;
      case "Archive Action":
        {
          await archiveAction({ actionId: action?.id });
          const tempArr = dataList.filter((x: any) => x.id != action.id);
          setDataList(tempArr);
        }
        break;
      case "Manage Access":
        const tempAccessData = {
          isOpen: true,
          itemId: action?.id,
        }
        setManageAccess(tempAccessData);
        break;
    }
  };

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: any
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  useEffect(() => {
    var tempData = data;
    if (
      (actionsSearchString != null && actionsSearchString.trim() !== "") ||
      (selectedArchivedStatuses && selectedArchivedStatuses.length > 0) ||
      (selectedActionsLinkedTo && selectedActionsLinkedTo.length > 0)
    ) {
      tempData = data.filter((item: any) => {
        const archivedStatusIds = selectedArchivedStatuses?.map(
          (status: any) => status.id
        );
        const selectedDeptIds = selectedDepartments?.map(
          (dept: any) => dept.id
        );
        const linkedToIds = selectedActionsLinkedTo?.map((si: any) => si.id);
        return (
          (actionsSearchString != null &&
            actionsSearchString.trim() !== "" &&
            (item.name
              .toLowerCase()
              .includes(actionsSearchString.toLowerCase()) ||
              (item.name &&
                item.name
                  .toLowerCase()
                  .includes(actionsSearchString.toLowerCase())) ||
              (item.ownerName &&
                item.ownerName
                  .toLowerCase()
                  .includes(actionsSearchString.toLowerCase())) ||
              (item.departmentName &&
                item.departmentName
                  .toLowerCase()
                  .includes(actionsSearchString.toLowerCase())))) ||
          (selectedArchivedStatuses &&
            selectedArchivedStatuses.length > 0 &&
            ((item.isArchived && archivedStatusIds.includes(2)) ||
              (!item.isArchived && archivedStatusIds.includes(1)) ||
              ((!item.isArchived || item.isArchived) &&
                archivedStatusIds.includes(0)))) ||
          (selectedDepartments &&
            selectedDepartments.length > 0 &&
            selectedDeptIds.includes(item.departmentId)) ||
          (selectedActionsLinkedTo &&
            selectedActionsLinkedTo.length > 0 &&
            ((item?.standards &&
              item?.standards?.length > 0 &&
              linkedToIds.includes(1)) ||
              (item?.licenceStandards &&
                item?.licenceStandards?.length > 0 &&
                linkedToIds.includes(2)) ||
              linkedToIds.includes(0)))
        );
      });
    }
    setDataList(tempData);
  }, [
    actionsSearchString,
    selectedArchivedStatuses,
    selectedDepartments,
    selectedActionsLinkedTo,
  ]);

  const visibleRows: any = React.useMemo(
    () =>
      setDataList(
        data?.length > 0 ? stableSort(data, getComparator(order, orderBy)) : []
      ),
    [order, orderBy, data]
  );

  //update project api
  const updateproject = async () => {
    const response = await editProject({
      projectId: selectedProject?.id,
      project: { ...selectedProject, actions: [newActionData] },
    });
    if (response) {
      const tempObj = { ...selectedProject, actions: response.action };
      dispatch(setSelectedProject(tempObj));
      dispatch(setProjectDetails(response));
    }
  };

  const manageCreateClick = () => {
    if (
      selectedProject &&
      selectedProject?.id &&
      Object.keys(newActionData).length > 0 &&
      Object.values(newActionData).some(
        (value) => value !== null && value !== ""
      )
    ) {
      const tempArr = dataList ? [...dataList, newActionData] : [newActionData];
      updateNewAction({ actions: tempArr });
      updateproject();
    } else if (!project?.id) {
      const tempArr = dataList ? [...dataList, newActionData] : [newActionData];
      updateNewAction({ actions: tempArr });
    }
    setNewActionData({});
    setAddNewAction(false);
  };

  const fetchActionList = async () => {
    const response = await getAllActions({
      clubId: clubDetails.id,
      isSelfAssessment: true,
    });
    setActionList(response);
  };
  const fetchStaffList = async () => {
    const response = await getStaff({ clubId: clubDetails?.id });
    setStaffList(response);
    // const selectedObj = response.find((item:any) => item.id == value);
    // setInputValue(selectedObj ? (selectedObj?.displayName || '') : '');
  };
  const fetchDepartmentList = async () => {
    const response = await getClubDepartments({ clubId: clubDetails?.id });
    setDepartmentList(response);
  };

  const manageStatus = async (status: any, action: any) => {
    const tempAction = { ...action, status: status };
    const response = await updateAction({
      actionId: action.id,
      action: tempAction,
    });
  };

  useEffect(() => {
    if (addNewAction && clubDetails && clubDetails?.id) {
      actionList && actionList.length == 0 && fetchActionList();
      staffList && staffList.length == 0 && fetchStaffList();
      departmentList && departmentList.length == 0 && fetchDepartmentList();
    }

    
    if (selectedActionRegex.test(location.pathname) ||
        selectedProjectActionRegex.test(location.pathname)) {
          const actionId = location.pathname.split('/')[isActions ? 3 : 5];
          if (data && data.length > 0) {
            const tempObj = data.find((d:any) => d.id == actionId);
            if (tempObj) {
              setActionData({...tempObj, projectIndex: 1});
            } 
          } else {
              const tempObj:any = {id: actionId, projectIndex: 1};
              setActionData(tempObj);
            }
            setOpenActionDetail(true);
        }
  }, [addNewAction, location]);

  const manageUserAccess = (isUpdated: any, restrictedUsers:any) => {
    if (isUpdated) {
        restrictActionUsers({clubId: clubDetails?.id, id: manageAccess?.itemId, users: restrictedUsers})
        .then(() => {
        })
        .catch((error:any) => {
          const warningData: any = {
            isOpen: true,
            severity: "error",
            message: error?.message || t("ACCESS_UPDATE_FAILED"),
          };
          dispatch(setSnackBarData(warningData));
        });
    }
    setManageAccess(initialAccessState);
  };

  //table contents
  return (
    <React.Fragment>
      <ThemeProvider theme={theme}>
        <Box sx={{ width: "100%", height: "100%" }}>
          <AccessManager isOpen={manageAccess?.isOpen} handleIsOpen={manageUserAccess} from={'actions'} itemId={manageAccess?.itemId} />
          <PerformanceActionDetailPopper
            isOpen={openActionDetail}
            handleClickAway={() => {
              setOpenActionDetail(false);
              isActions ? navigate("/performanceplan/actions") : navigate(`/performanceplan/projects/${project?.id}`);
            }}
            actionData={actionData}
            projectData={data}
            isReadOnly={isAdmin}
          />
          <PerformanceNewActionDetailPopper
            isOpen={addNewAction && isActions}
            handleClickAway={() => {
              setAddNewAction(false);
            }}
          />
          <TableContainer
            sx={{ maxHeight: "100%", overflowY: "auto", width: "100%" }}
          >
            <Table stickyHeader size="small" aria-label="a dense table">
              <EnhancedTableHead
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                tableHeads={
                  !project ? head : head.filter((d) => d.key !== "projectName")
                }
                bg="#fff"
              />
              <TableBody>
                {!isLoading && dataList?.length ? (
                  dataList.map((d: any, i: number) => (
                    <TableRow
                      sx={{ cursor: "pointer" }}
                      key={`actions-table-row-${i}`}
                    >
                      <TableCell className="fs12">
                        {from === t("ACADEMY_GOALS")
                          ? `A${i + 1}`
                          : `A${project ? project?.projectIndex + "." + (i + 1) : i + 1}`}
                        {d?.isCreatedByJL && (
                          <img
                            className="smallLogoForTables ml10 displayinlineBlock mtbAuto"
                            src={logo}
                            alt="JL Logo"
                          />
                        )}
                      </TableCell>
                      <TableCell
                        className="fs12"
                        sx={{ width: "500px" }}
                        onClick={() => {
                          setActionData({
                            ...d,
                            actionIndex: project
                              ? project?.projectIndex + "." + (i + 1)
                              : i + 1,
                          });
                          setOpenActionDetail(true);
                          actionsRegex.test(location.pathname)
                            ? navigate("/performanceplan/actions/" + d.id)
                            : selectedProjectRegex.test(location.pathname) &&
                              navigate(
                                `/performanceplan/projects/${d.projectId}/actions/${d.id}`
                              );
                        }}
                      >
                        {d.name?.length > 40 && false
                          ? d.name.slice(0, 40) + "..."
                          : d.name}
                      </TableCell>
                      <TableCell>
                        {project?.id !== null && project?.id !== undefined && (
                          <Box sx={{ display: "flex" }}>
                            {d?.isCreatedByJL ? (
                              <img
                                className="smallLogoForTables ml10 displayinlineBlock"
                                src={logo}
                                alt="JL Logo"
                              />
                            ) : (
                              <Box className={"smallLogoForTables ml10"} />
                            )}
                            <CommentsDocsActionsIconWrapper
                              comments={d?.comments ? d?.comments : 0}
                              tasks={
                                d?.tasks?.length > 0 ? d?.tasks?.length : 0
                              }
                            />
                          </Box>
                        )}
                      </TableCell>
                      {!project && (
                        <TableCell className="fs12">{d.projectName}</TableCell>
                      )}
                      <TableCell
                        className={
                          isAdmin && !d?.isCreatedByJL
                            ? "fs12 cursorNotAllowed"
                            : "fs12"
                        }
                      >
                        <SelectBoxPrimary
                          label={""}
                          options={[0, 1, 2, 3, 4]}
                          isStatus={true}
                          selected={d?.ragb ? d.ragb : 4}
                          manageChange={(e: any) => {
                            manageStatus(e, d);
                          }}
                          report={"rabg"}
                          disabled={isAdmin && !d?.isCreatedByJL}
                        />
                      </TableCell>
                      <TableCell className="fs12">
                        {d?.ownerName ? d?.ownerName : "-"}
                      </TableCell>
                      <TableCell className="fs12">
                        {d?.departmentName ? d?.departmentName : "-"}
                      </TableCell>
                      <TableCell className="fs12" sx={{ width: '120px' }}>
                        {d?.dueDate ? formatDate(d.dueDate) : "-"}
                      </TableCell>
                      <TableCell sx={{ width: "1px" }}>
                        {
                          // ((!isAdmin && !d?.isCreatedByJL) || (isAdmin && d?.isCreatedByJL)) &&
                          (!isAdmin && !d.isRestricted) && (
                            <NestedThreeDotMenu
                              options={threeDotMenuOptions}
                              manageClick={(e: any) => {
                                handleThreedotMenuClick(e, d);
                              }}
                            />
                          )
                        }
                      </TableCell>
                    </TableRow>
                  ))
                ) : !isLoading &&
                  (dataList?.length == 0 || dataList == undefined) ? (
                  !addNewAction && (
                    <TableRow>
                      <TableCell
                        colSpan={head?.length}
                        className="fs12"
                        sx={{ textAlign: "center" }}
                      >
                        No Action Found
                      </TableCell>
                    </TableRow>
                  )
                ) : (
                  <TableSkeleton rowCount={6} cellCount={head?.length} />
                )}
                {/* add new action in table */}
                {!isActions && addNewAction ? (
                  <TableRow
                    sx={{ cursor: "pointer" }}
                    key={`actions-table-row-create`}
                  >
                    <TableCell></TableCell>
                    <TableCell className="fs12">
                      <ActionSelectBox
                        optionList={actionList}
                        variant={"standard"}
                        selected={newActionData?.name}
                        manageActionSelect={(data: any) => {
                          if (data && Object.keys(data).includes("id")) {
                            setNewActionData({ ...data, standardHistory: [] });
                          } else {
                            setNewActionData({
                              ...newActionData,
                              ...data,
                              standardHistory: [],
                              isCreatedByJL: isAdmin,
                            });
                          }
                        }}
                      />
                    </TableCell>
                    <TableCell></TableCell>
                    <TableCell className="fs12">
                      <SelectBoxPrimary
                        label={""}
                        options={[0, 1, 2, 3, 4]}
                        isStatus={true}
                        selected={
                          newActionData?.status ? newActionData?.status : 0
                        }
                        manageChange={(stat: any) => {
                          setNewActionData({
                            ...newActionData,
                            status: stat,
                            isCreatedByJL: isAdmin,
                          });
                        }}
                        report={"rabg"}
                      />
                    </TableCell>
                    <TableCell className="fs12">
                      <Box sx={{ width: "120px" }}>
                        <StaffSelectBox
                          options={staffList}
                          variant={"standard"}
                          selectedValue={newActionData?.ownerUserId}
                          manageSelect={(data: any) => {
                            setNewActionData({
                              ...newActionData,
                              ownerName: data.displayName,
                              ownerUserId: data.id,
                              standardHistory: [],
                              isCreatedByJL: isAdmin,
                            });
                          }}
                        />
                      </Box>
                    </TableCell>
                    <TableCell className="fs12">
                      <StaffSelectBox
                        options={departmentList}
                        variant={"standard"}
                        selectedValue={newActionData?.projectId}
                        manageSelect={(e: any) => {
                          setActionData({
                            ...newActionData,
                            departmentName: e.name,
                            departmentId: e.id,
                            standardHistory: [],
                          });
                        }}
                      />
                    </TableCell>
                    <TableCell className="fs12">
                      <Box sx={{ width: "120px" }}>
                        <DateSelector
                          variant="standard"
                          dateValue={
                            newActionData?.dueDate
                              ? formatDate(newActionData?.dueDate)
                              : null
                          }
                          manageChange={(e: any) => {
                            setNewActionData({
                              ...newActionData,
                              dueDate: e ? e : null,
                              standardHistory: [],
                              isCreatedByJL: isAdmin,
                            });
                          }}
                        />
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: "flex" }}>
                        <Tooltip title="Delete" arrow placement="top">
                          <FontAwesomeIcon
                            onClick={() => {
                              setNewActionData({});
                              setAddNewAction(false);
                            }}
                            className={"icon mr10"}
                            icon={faXmark}
                          />
                        </Tooltip>
                        <Tooltip title="Create" arrow placement="top">
                          <FontAwesomeIcon
                            onClick={() => {
                              manageCreateClick();
                            }}
                            className={"icon mr10"}
                            icon={faCheck}
                          />
                        </Tooltip>
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : (
                  isAddLoading && <TableSkeleton rowCount={1} cellCount={8} />
                )}
              </TableBody>
            </Table>
          </TableContainer>
          {!isReadOnly && !isAdmin && (
            <Box sx={{ float: "left", mt: 2 }}>
              <ButtonDefault
                variant={"outlined"}
                value={t("ADD_ACTION")}
                icon={
                  <FontAwesomeIcon className={"fs13"} icon={faCirclePlus} />
                }
                manageOnClick={() => {
                  setAddNewAction(true);
                }}
                disabled={addNewAction}
              />
            </Box>
          )}
        </Box>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default PerformanceActionsTable;
